export var ERR_GENERIC = {
    message: 'Something went wrong. Refresh the page and try again.',
};
export var ERR_REDIRECT = {
    message: "We're redirecting you to sign in to your account.",
};
export var ERR_SETTINGS = {
    message: "We couldn't load your settings. Refresh the page and try again.",
};
export var ERR_SAVE_CHANGES = {
    message: "We're unable to save your changes. Refresh the page and try again.",
};
export var ERR_SHOPPER_HAS_ACTIVE_ALLOWANCE = {
    message: 'This shopper has an active allowance. Disable their current allowance and assign a new allowance or choose a different shopper.',
};
